import { IBranding } from '@/feed/Feed.interface'
import Toolbar from './Toolbar'

export const isToolbarHidden = (branding: IBranding | null) =>
  !!branding && branding.enabled && branding.feedHideToolbar

function BrandedToolbar({ branding }: { branding: IBranding | null }) {
  if (isToolbarHidden(branding)) {
    return null
  }

  return (
    <Toolbar
      title={branding?.enabled ? branding?.feedTitle : undefined}
      hideArrow={branding?.enabled && branding?.feedHideToolbarBackArrow}
      arrowColor={branding?.enabled ? branding?.feedArrowColor : undefined}
      titleColor={branding?.enabled ? branding?.feedTitleColor : undefined}
    />
  )
}

export default BrandedToolbar
